










































  import { Component, Prop, Vue } from "vue-property-decorator";
  import YcHeader from "@/components/common/yc-header.vue";
  import YcAside from "@/components/common/yc-aside.vue";
  import YcColorPicker from "@/components/color-picker/index.js";
  import fortuneStyle from './components/style.vue';
  import Text from './components/text.vue'
  import {
    getCountryPhoneCodeCodeList
  } from "@/services/api"
import { getVueAppUploadApi } from "@/services/util";

  enum permissionType {EDIT = 'edit', CHECK = 'check'}

  @Component({
    components: {
      "yc-aside": YcAside,
      "yc-header": YcHeader,
      "yc-color-picker": YcColorPicker,
      "fortune-style": fortuneStyle,
      "text-exhibition": Text
    },
  })
  export default class styleSetting extends Vue {

    @Prop(String)
    activePageSetting!:string;
    // 大转盘数据
    @Prop(Object)
    formData!:object;


    // 激活的标签
    pageSettings = [
      {value: 'start', label: this.$tx('form.edit.step.start', '开始')},
      {value: 'end', label: this.$tx('form.completed', '结束')},
      {value: 'packUp', label: this.$tx('form.edit.step.packUp', '收起')}
    ]



    public color =  '#000';
    public imgNameArr = [
      { imgName: 'left_top_', top: '20px', left: '20px' },
      { imgName: 'right_top_', top: '20px', right: '20px' },
      { imgName: 'left_center_', top: '47%', left: '20px' },
      { imgName: 'right_center_', top: '47%', right: '20px' },
      { imgName: 'left_bottom_', bottom: '20px', left: '20px' },
      { imgName: 'right_bottom_', bottom: '20px', right: '20px' }
    ]
    public selectImgVis = 1
    // 颜色选择色盘
    public predefineColors = [
      '#ff4500',
      '#ff8c00',
      '#ffd700',
      '#90ee90',
      '#00ced1',
      '#1e90ff',
      '#c71585',
      '#f1b859',
      '#f4994b',
      '#d7394d',
      '#dd5b46',
      '#f7d69e',
    ]
    public uploadShow = false;
    public uploadDialogVisible = false;
    public uploadDialogUrl = '';
    public uploadFileList: {name: string, url: string}[] = [];

    // 上传图片地址
    public uploadUrl = getVueAppUploadApi() + "/upload/formImage";
    get token() {
      return localStorage.getItem("token") || "default";
    }


    changeText(e:any){
    this.$emit('changeformData',e)
  }



    changeActivePageSetting(val:string){
      this.$emit('changeActivePageSetting',val)
    }

    /**
     * 下一步
     */
    nextStep() {
      this.$emit('nextStep')
    }

    /**
     * 上一步
     */
    backStep() {
      this.$emit('backStep')
    }

    /**
     * 取消
     */
    cancel() {
      this.$emit('cancel')
    }

    countryList = []

    async created(): Promise<void> {
      this.getPhoneCodeCodeList()
    }

    async getPhoneCodeCodeList() {
      let {data ,status }  = await getCountryPhoneCodeCodeList({},true)
      if (status == 200) {
          this.countryList = data.data
      }
    }

  }
  